﻿﻿export interface ITicketMessageFile {
    id: number;
    fileName: string;
    fileIndex: number;
}
